import template from './estate-list.pug';

export const EstateListComponent = {
  template,
  bindings: {
    filter: '<',
    isModal: '<?',
    onCheck: '&?'
  },
  controller: class EstateListComponent {
    constructor(Estate, User, RecordStatus, $rootScope, LocalStorage, Signal, Account, Table, TableEdit, MediaQuery, $stateParams, $scope, $state, $async, $log) {
      'ngInject';
      this.$stateParams = $stateParams;
      this.$state = $state;
      this.$rootScope = $rootScope;
      this.Estate = Estate;
      this.User = User;
      this.Table = Table;
      this.TableEdit = TableEdit;
      this.RecordStatus = RecordStatus;
      this.LocalStorage = LocalStorage;
      this.Signal = Signal;
      this.$log = $log;
      this.getUser = $async(this.getUser.bind(this));
      this.getAccountStats = $async(this.getAccountStats.bind(this));
      this.getEstates = $async(this.getEstates.bind(this));
      this.Account = Account;
      this.totalRecords = 1;
      this.selectedEstateTypes = [];
      this.activeTab = 'table';

      this.isMobile = MediaQuery.isMobileDevice();
      this.sidebarOpen = !this.isMobile;

      $scope.$on('mediaChange', function(event, data) {
        $scope.isMobile = data.isMobile;
        $scope.sidebarOpen = !data.isMobile;
      });
    }

    $onInit() {
      this.getAccountStats();

      this.gridOptions = this.TableEdit.gridOptions(this.isModal);
      this.gridOptions.columnDefs = this.TableEdit.resolveColumns('estate', 'estate', this.isModal);
      if (this.selectedStatusId === undefined) {
        this.selectedStatusId = this.RecordStatus.returnLastStatusId('estate');
      }

      this.filter = angular.copy(this.filter);
      if (this.$stateParams.user_id) {
        this.getUser(this.$stateParams.user_id);
      }

      this.Signal.listen('onFilterColumnReset', this.$rootScope, (key) => {
        if (key === 'estate_type_id') {
          this.selectedEstateTypes = [];
        }
      });

      this.Signal.listen('toggleSideBar', this.$rootScope, () => {
        this.sidebarOpen = !this.sidebarOpen;
      });

      if (this.isMobile) {
        this.getEstates();
      }
    }

    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    }

    changeView({ tab }) {
      this.activeTab = tab;
      this.getEstates();
    }

    selectEstateType(type) {
      if (this.selectedEstateTypes.includes(type.id)) {
        this.selectedEstateTypes = this.selectedEstateTypes.filter(id => id !== type.id);
      } else {
        this.selectedEstateTypes.push(type.id);
      }
      this.filter.estate_type_id = this.selectedEstateTypes.filter(id => parseInt(id) > 0 );
      this.Signal.send('filterChanged:estate', this.filter);
      this.getEstates();
    }


    async getEstates() {
      try {

        if (!this.filter) return;

        if (this.Table.activeFilters.loading && !this.isModal && !this.isMobile) return;
        const apiFilter = this.filter;
        if (this.isMobile) {
          apiFilter.mobile = 1;
        }
        apiFilter.serializer = this.activeTab;
        this.loader = true;

        const { data, meta } = await this.Estate.list(apiFilter);

        this.records = data;
        this.totalCount = meta.total_count;
        this.totalPages = meta.pages;
        this.recordStatuses = meta.record_statuses;
        this.estateTypes = meta.estate_types;
        if (meta.cf_names && meta.cf_names.length) {
          let settings = await this.LocalStorage.settings('estate', 'custom_table_fields');
          settings.cf_names = meta.cf_names;
          const resp = this.TableEdit.recheckNames(settings, 'estate');
          if (resp.update) {
            this.gridOptions.columnDefs = this.TableEdit.resolveColumns('estate', this.isModal);
          }
        }

        if (meta.options) meta.options.forEach(element => {
          let field = this.gridOptions.columnDefs.find(elm => elm.field_key === element.technical_name);
          if (!field) return;


          if (element.field_type && element.field_type == 'connected_record') {
            field.filter.validations = element.validations;
          }

          if (element.options.length) {
            field.filter.selectOptions = element.options;
          }
          // this.gridOptions.columnDefs[this.gridOptions.columnDefs.indexOf(field)] = {};

        });
      } catch (e) {
        this.$log.error(e);
      } finally {
        this.loader = false;
      }
    }

    async getAccountStats() {
      try {
        const response  = await this.Account.getAccountStatsByModule('estate');
        this.totalRecords = response.count;
      } catch (e) {
        this.$log.log(e);
      }
    }

    async getUser(user_id) {
      try {
        this.user = await this.User.cardInfo(user_id);
      } catch (e) {
        this.$log.log(e);
      }
    }

    selectStatus(statusId) {
      this.selectedStatusId = statusId;
      this.Signal.send('estateStatusChange', this.selectedStatusId);
      this.RecordStatus.setLastStatusId('estate', statusId);
      this.applyFilterAndResetPage({ filter: this.filter, statusId });
      if (this.isMobile) {
        this.toggleSidebar();
      }
    }

    applyFilterAndResetPage({ filter, searchId, statusId }) {
      if (searchId) {
        this.$stateParams.searchId = searchId;
      } else {
        searchId = -1;
      }
      filter.custom_view_id = searchId;

      statusId = this.RecordStatus.returnLastStatusId('estate') || [-1];
      filter.record_status_id = statusId;
      this.applyFilter(filter);
      this.updatePage({ page: filter.page || 1, searchId, statusId });
      this.getEstates();
    }


    updatePage({ page, searchId, statusId }) {
      searchId = searchId || this.$stateParams.searchId;

      statusId = statusId || this.RecordStatus.returnLastStatusId('estate') || [-1];
      this.statusId = statusId;

      this.LocalStorage.set('estate', 'list_page', page);

      this.$state.go('.', { page, searchId, statusId });
      this.filter.page = page;
      // this.$onInit();
    }

    applyFilter(filter) {
      if (!{}.hasOwnProperty.call(filter, 'user_id') && this.$stateParams.user_id) {
        this.filter = { ...filter, user_id: this.$stateParams.user_id } || {};
      } else if (this.$stateParams.customFieldId && this.$stateParams.destinationId && this.$stateParams.destinationType) {
        this.filter = {
          ...filter,
          connected_record: {
            custom_field_id: this.$stateParams.customFieldId,
            destination_id: this.$stateParams.destinationId,
            destination_type: this.$stateParams.destinationType
          }
        } || {};
      } else {
        this.filter = filter || {};
      }
    }

    doCheck({ checkedIds }) {
      if (this.onCheck) {
        this.onCheck({
          $event: { checkedIds }
        });
      }
    }

  }
};
